<template>
  <van-popup class="wrap" v-model="value" @click-overlay="setTime(false)" :close-on-click-overlay="false">
    <div class="m-tier">
      <!-- 年份 月份 -->
      <div class="month">
        <ul class="m-box">
          <li class="m-year">
            <i class="icon icon-arrow-left" @click.stop="prevMonth()"></i>
            <span>{{ yearData }}年{{ monthData }}月</span>
            <i class="icon icon-arrow-right" @click.stop="nextMonth()"></i>
          </li>
          <li class="m-week">
            <span>日</span>
            <span>一</span>
            <span>二</span>
            <span>三</span>
            <span>四</span>
            <span>五</span>
            <span>六</span>
          </li>
          <li class="m-day">
            <div class="m-row" v-for="(arr, index) in dayArrays" :key="index">
              <div class="m-chunk" v-for="item in arr" @click.stop="selected(item, index)" :key="item.id">
                <span
                  class="m-date"
                  :class="{
                    'm-today': item.state && item.state.code === '000' && item.state.specialProDtos && item.state.specialProDtos.length,
                    'm-active': item.dayNum === activeIndex && item.state && item.state.code === '000' && item.state.specialProDtos && item.state.specialProDtos.length,
                    'm-isGreen': item.dayNum === activeIndex && item.state && item.state.code === '000' && (!item.state.specialProDtos || !item.state.specialProDtos.length),
                    'm-disabled': !item.state || (item.state && item.state.code !== '000'),
                    'm-red': item.state && item.state.code === '010' && dateTips(item)
                  }"
                  >{{ item.dayNum }}</span
                >
                <span
                  class="m-alert"
                  :class="{
                    'm-full': item.state && item.state.code === '000' && item.state.specialProDtos && item.state.specialProDtos.length,
                    'm-red': item.state && item.state.code === '010',
                    'm-on': item.state && item.state.code === '000'
                  }"
                  v-if="item.dayNum"
                  v-html="dateTips(item)"
                ></span>
              </div>
              <div class="m-time" v-if="specialMap[activeDate.dateStr] && index === timeIndex">
                <p class="m-full">{{ activeDate.dateStr.split('-')[1] }}月{{ activeDate.dateStr.split('-')[2] }}日以下项目{{ specialProDtosText }}，请选择其他日期</p>
                <div class="projects" v-if="showPhyDel">
                  <button v-for="(r, index) in specialMap[activeDate.dateStr]" @click.stop="specialHandler(r, index)" v-if="showClearBtn" class="m-activeTime" :key="index">
                    {{ r.projectName }}
                    <i class="icon icon-close"> </i>
                  </button>
                  <button v-for="(r, index) in specialMap[activeDate.dateStr]" v-if="!showClearBtn" class="m-activeTime hideClearBtn" :key="index">
                    {{ r.projectName }}
                  </button>
                </div>
                <div class="projects" v-if="!showPhyDel">
                  <button v-for="(r, index) in specialMap[activeDate.dateStr]" v-if="showClearBtn" class="m-activeTime" :key="index">
                    {{ r.projectName }}
                  </button>
                  <button v-for="(r, index) in specialMap[activeDate.dateStr]" v-if="!showClearBtn" class="m-activeTime hideClearBtn" :key="index">
                    {{ r.projectName }}
                  </button>
                </div>
              </div>
              <div class="m-time" v-if="!specialMap[activeDate.dateStr] && index === timeIndex && testTimes.length > 0">
                <p class="text-center">请选 {{ activeDate.dateStr.split('-')[1] }}月{{ activeDate.dateStr.split('-')[2] }}日的体检时间段</p>
                <div class="time-quantum">
                  <div v-for="(r, $index) in testTimes">
                    <button
                      :class="{
                        'm-disabledTime': r.code === '010' || r.code === '030' || testTiesDisabledList.includes($index),
                        'm-activeTime': $index === activeTime
                      }"
                      :key="'testTimes' + $index"
                      @click="selectedTimeQuantum(r, $index)"
                      style="font-size: 13px"
                    >
                      {{ r.testTime }}
                      <span>{{ r.code === '010' ? '(已满)' : r.code === '030' ? '(已过)' : '(余' + r.numberOfPeople + '人)' }}</span>
                    </button>
                  </div>
                  <div v-show="activeTime && testTimes[activeTime] && testTimes[activeTime].specialProDtos && testTimes[activeTime].specialProDtos.length"></div>
                </div>
              </div>
              <div class="m-time" v-if="fastingProjectList.length && index === timeIndex && testTiesDisabledList.includes(activeTime)">
                <p>以下空腹项目在此时间段不能体检</p>
                <div class="projects">
                  <button v-for="(r, index) in fastingProjectList" @click.stop="specialHandler(r, index)" class="m-activeTime m-error-bg" :key="index">
                    {{ r.projectName }}
                    <i class="icon icon-close" v-if="showClearBtn"> </i>
                  </button>
                </div>
              </div>
            </div>
          </li>

          <li class="m-foot">
            <button class="btn" @click.stop="setTime(false)" v-if="showColse">取消</button>
            <button
              :disabled="disableSubmit || !affirmTime || testTiesDisabledList.includes(activeTime)"
              class="btn"
              :class="{'btn-dis': disableSubmit || !affirmTime || testTiesDisabledList.includes(activeTime)}"
              @click.stop="setTime(true)"
            >
              确定
            </button>
          </li>
        </ul>
      </div>
    </div>
  </van-popup>
</template>

<script>
import {Icon} from '@/components/common'
import {Popup} from 'vant'
import Vue from 'vue'

Vue.use(Popup)
/**
 *  <date-picker v-model="dateState"  @getTime="getTime"></date-picker>
 *   v-model 控制显示/隐藏   @getTime 返回已选择的时间
 */
export default {
  components: {Icon},
  props: {
    fastingProjectList: {
      type: Array,
      default: function () {
        return []
      }
    },
    fastingCheckDate: {
      type: Object,
      default: function () {
        return {
          startHour: '',
          startMinute: '',
          endHour: '',
          endMinute: ''
        }
      }
    },
    showClearBtn: {
      type: Boolean,
      default: true
    },
    showPhyDel: {
      type: Boolean,
      default: true
    },
    showColse: {
      type: Boolean,
      default: true
    },
    value: {
      type: Boolean,
      default: false
    },
    dateList: {
      type: Array,
      default: []
    }
  },
  data() {
    return {
      yearData: '',
      monthData: '',
      dayData: '',
      days: '', // 当月多少天
      week: '', //当天星期几
      dayArrays: [],
      activeDate: '',
      testTimes: [], //时间段List
      activeIndex: '', //选择天
      timeIndex: '', //时间选区
      activeTime: '', //选择时间段下标
      affirmTime: '', //时间段
      affirmTimeObj: {} //时间段
    }
  },
  created() {
    const {year, month, day} = this.showDate() //获得当前年月日
    this.getData(year, month, day) //获得日历数据
  },
  watch: {
    testDateList(newVal) {
      if (newVal) {
        this.updateView()
      }
    }
  },
  methods: {
    dateTips(item) {
      if (item.state && item.state.code === '010') {
        return '已满'
      } else if (item.state && item.state.code === '020') {
        return '休息'
      } else if (item.state && item.state.code === '000') {
        if (item.state.specialProDtos && item.state.specialProDtos.length) {
          // if(item.state.specialProDtos.some(obj=>))
          return '限约'
        }
        return '可约'
      } else {
        return '&nbsp;'
      }
    },
    updateView() {
      const {year, month, day} = this.showDate(this.activeDate ? new Date(this.activeDate.dateStr) : new Date(this.testDateList[0].testDate)) //获得当前年月日
      this.getData(year, month, day) //获得日历数据
    },
    selected(item, index) {
      if (item.state && item.state.code === '000') {
        this.activeDate = item
        this.activeIndex = item.dayNum
        this.dayData = item.dayNum < 10 ? '0' + item.dayNum : item.dayNum
        this.testTimes = item.state.testTimes
        this.timeIndex = index
        this.activeTime = ''
        this.affirmTime = ''
        this.affirmTimeObj = {}
        let showTimeQuantum = this.testTimes.filter(obj => {
          return obj.code === '000'
        })
        if (showTimeQuantum.length === 1) {
          this.activeTime = this.testTimes.findIndex(obj => {
            return obj.code === '000'
          })
          this.affirmTime = showTimeQuantum[0].testTime
          this.affirmTimeObj = showTimeQuantum[0]
        }
      }
    },
    selectedTimeQuantum(item, index) {
      if (item.code && item.code === '000') {
        this.activeTime = index
        this.affirmTime = item.testTime
        this.affirmTimeObj = item
      }
    },
    specialHandler(specialProject, index) {
      if (this.showClearBtn) {
        this.$emit('specialHandler', this.activeDate, specialProject)
      }
    },
    setTime(bool) {
      console.log('1')
      this.$emit('input', false)
      if (bool) {
        this.$emit('getTime', {
          date: `${this.yearData}-${this.monthData}-${this.dayData}`,
          time: this.affirmTimeObj.testTime,
          id: this.affirmTimeObj.no
        })
      }
    },
    showDate(d) {
      let date = d || new Date() // 获得当前日期
      this.yearData = date.getFullYear()
      this.monthData = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1
      return {year: date.getFullYear(), month: date.getMonth() + 1, day: date.getDate()}
    },
    prevMonth() {
      this.activeIndex = ''
      this.timeIndex = ''
      this.dayData = ''
      let y = this.yearData
      let m = parseInt(this.monthData)
      if (m === 1) {
        y -= 1
        m = 13
      }
      this.yearData = y
      this.monthData = m - 1 < 10 ? '0' + (m - 1) : m - 1
      this.getData(y, m - 1)
    },
    nextMonth() {
      this.activeIndex = ''
      this.timeIndex = ''
      this.dayData = ''
      let y = this.yearData
      let m = parseInt(this.monthData)
      if (m >= 12) {
        y += 1
        m = 0
      }
      this.yearData = y
      this.monthData = m + 1 < 10 ? '0' + (m + 1) : m + 1
      this.getData(y, m + 1)
    },
    getData(year, month, day) {
      this.days = new Date(year, month, 0).getDate() // 获得当月总天数
      this.week = new Date(year, month - 1, 1).getDay() // 当月第一天星期几
      // 获得当月数据对象
      let vessel = []
      let dateStr
      for (let i = 1; i <= this.days; i++) {
        dateStr = [year, (month + Math.pow(10, 2)).toString().substr(1), (i + Math.pow(10, 2)).toString().substr(1)].join('-')
        vessel.push({
          state: (this.testDateList || []).find(date => date.testDate === dateStr),
          dateStr: dateStr,
          dayNum: i,
          weekDay: new Date(year, month - 1, i).getDay(),
          selected: i === +day,
          isThisMonth: parseInt(this.monthData) === new Date().getMonth() + 1, //是否是本月
          today: i === new Date().getDate() //是否是今天
        })

        if (this.activeDate && this.activeDate.dateStr === dateStr) {
          this.activeDate = vessel[vessel.length - 1]
        }
      }
      // 每月第一天不是星期天 补空
      let sum = vessel[0].weekDay
      for (let i = 0; i < sum; i++) {
        if (sum <= 6 && sum !== 0) {
          vessel.unshift({})
        }
      }
      // 分星期重组数据
      let arr = []
      let row = []
      for (let r = 1; r <= vessel.length; r++) {
        row.push(vessel[r - 1])
        if (r % 7 === 0 || r === vessel.length) {
          arr.push(row)
          row = []
        }
      }
      this.dayArrays = arr
    }
  },
  computed: {
    //      fastingCheckDate: {
    //        get: function () {
    //          return this.fastingDate
    //        }
    //      },
    //      fastingProjectList: {
    //        get: function () {
    //          return this.fastingProList
    //        }
    //      },
    testTiesDisabledList() {
      let list = []
      if (this.fastingProjectList && this.fastingProjectList.length) {
        this.testTimes.forEach((obj, index) => {
          let testTime = (obj && obj.testTime) || '00:00~24:00'
          let startDate = testTime.split('~')[0].split(':')
          let endDate = testTime.split('~')[1].split(':')
          if (
            parseInt(startDate[0]) > this.fastingCheckDate.endHour ||
            (parseInt(startDate[0]) == this.fastingCheckDate.endHour && parseInt(startDate[1]) > this.fastingCheckDate.endMinute) ||
            parseInt(endDate[0]) < this.fastingCheckDate.startHour ||
            (parseInt(endDate[0]) == this.fastingCheckDate.startHour && parseInt(endDate[1]) < this.fastingCheckDate.startMinute)
          ) {
            list.push(index)
          }
        })
      }
      console.log(this.testTimes && this.testTimes[this.activeTime] && this.testTimes[this.activeTime].testTime)
      return list
    },
    //        testTimesSpecialProDtos () {
    ////        console.log(this.testTiesDisabledList)
    //
    ////        let testTime = this.testTimes && this.testTimes[this.activeTime] && this.testTimes[this.activeTime].testTime
    //          console.log(this.activeTime)
    //
    //
    //      },
    testDateList: {
      get: function () {
        return this.dateList
      }
    },
    disableSubmit() {
      return !this.activeDate || (this.activeDate && this.activeDate.state && this.activeDate.state.specialProDtos && this.activeDate.state.specialProDtos.length > 0)
    },
    specialProDtosText() {
      // let str = ''
      // console.log(this.activeDate.dateStr)
      // console.log()
      // for (let date of this.testDateList) {
      let stringLs = []
      let list = this.specialMap[this.activeDate.dateStr] || []
      if (
        list.some(obj => {
          return obj.code === '020'
        })
      ) {
        stringLs.push('限约')
      }
      if (
        list.some(obj => {
          return obj.code === '010'
        })
      ) {
        stringLs.push('满约')
      }
      // list.forEach(obj => {

      //   if (
      //     date.specialProDtos.some(obj => {
      //       return obj.code !== '020'
      //     })
      //   ) {
      //     stringLs.push('满约')
      //   }
      //   date.specialProDtosText = list.join('/')
      // })

      return stringLs.join('/')
    },
    specialMap() {
      let map = {}
      for (let date of this.testDateList) {
        if (date.code === '000' && date.specialProDtos && date.specialProDtos.length > 0) {
          let list = []
          map[date.testDate] = date.specialProDtos
          date.specialProDtosCode = true
          console.log(
            date.specialProDtos.some(obj => {
              return obj.code === '020'
            })
            // map
          )
          if (
            date.specialProDtos.some(obj => {
              return obj.code === '020'
            })
          ) {
            list.push('限约')
          }
          if (
            date.specialProDtos.some(obj => {
              return obj.code !== '020'
            })
          ) {
            list.push('满约')
          }
          date.specialProDtosText = list.join('/')
        } else {
          map.specialProDtosCode = false
        }
      }
      return map
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style ref="stylesheet/scss" lang="scss" scoped>
  @import "@/assets/style/variables.scss";
.van-popup /deep/ {
  width: 90%;
  .m-tier {
    background-color: rgba(7, 17, 27, 0.7);
    display: flex;
    display: -webkit-flex;
    align-items: center;
    justify-content: center;
  }

  .month {
    flex: 0 337px;
  }

  .m-box {
    margin: auto;
    padding: 10px 10px;
    background-color: #ffffff;
    border-radius: 4px;
    .m-year {
      display: flex;
      justify-content: space-between;
      height: 40px;
      line-height: 40px;
    }
    .m-week {
      width: 100%;
      height: 36px;
      line-height: 36px;
      color: #999999;
      span {
        display: inline-block;
        width: 14.28%;
        text-align: center;
      }
    }
    .m-day {
      width: 100%;
      .m-alert {
        display: block;
        font-size: 12px;
        line-height: 1;
        color: #dddddd;
      }
      .m-on {
        color: $assertive;
      }
      .m-red {
        color: red;
      }
      .m-off {
        color: #3ec8ff;
      }
      .m-full {
        color: $assertive !important;
      }
      .m-row {
        width: 100%;
        min-height: 40px;
        .m-chunk {
          display: inline-block;
          width: 14.28%;
          text-align: center;
          .m-date {
            display: inline-block;
            margin: 4px auto;
            width: 26px;
            height: 26px;
            line-height: 26px;
          }
        }
      }
    }
    .m-foot {
      width: 100%;
      padding-top: 10px;
      text-align: center;
      > button {
        height: 30px;
        padding: 0 15px;
        border: 1px solid $assertive;
        &:first-child {
          margin-right: 40px;
          background-color: #ffffff;
          color: $assertive;
        }
        &:last-child {
          background-color: $assertive;
          color: #ffffff;
        }
      }
    }
  }

  .m-date {
    color: $assertive;
  }

  .m-disabled {
    color: #999;
    text-decoration: line-through;
  }

  .m-today {
    color: $assertive;
  }

  .m-active {
    color: #ffffff;
    background-color: $assertive;
    border-radius: 50%;
  }
  .m-isGreen {
    color: #ffffff;
    background-color: $assertive;
    border-radius: 50%;
  }

  .m-activeTime {
    border-color:$assertive !important;
    color: #ffffff;
    background-color: $assertive !important;
  }
  .m-error-bg {
    border-color: $assertive !important;
    background-color: $assertive !important;
  }
  .m-time {
    width: 100%;
    max-height: 125px;
    text-align: center;
    padding: 0 15px;
    border-top: 1px solid #f5f5f5;
    border-bottom: 1px solid #f5f5f5;
    overflow-y: auto;
    p {
      line-height: 36px;
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
    }

    > .time-quantum {
      display: flex;
      flex-wrap: wrap;
      justify-content: left;
      /*padding-left: 25px;*/
      align-content: space-between;
      div {
        flex: 0 0 50%;
      }
      button {
        width: 130px;
        height: 30px;
        line-height: 28px;
        border-radius: 4px;
        margin-bottom: 15px;
        border: 1px solid #dddddd;
        background-color: #ffffff;
        &:nth-child(even) {
          margin-right: 0;
        }
      }

      /*.m-activeTime {*/
      /*border-color: #f25930;*/
      /*color: #ffffff;*/
      /*background-color: #f25930;*/
      /*}*/

      .m-disabledTime {
        border-color: #dddddd;
        color: #ffffff;
        background-color: #dddddd;
      }
    }
    .projects {
      display: flex;
      line-height: 36px;
      flex-wrap: wrap;
      justify-content: space-between;
      align-content: space-between;
      button {
        display: flex;
        justify-content: space-between;
        padding: 0 6px;
        width: 130px;
        height: 30px;
        line-height: 28px;
        border-radius: 4px;
        margin-right: 15px;
        margin-bottom: 15px;
        border: 1px solid #dddddd;
        background-color: #ffffff;
        &:nth-child(even) {
          margin-right: 0;
        }
      }
    }
  }

  .btn-dis {
    border: 1px solid #ddd !important;
    background-color: #ddd !important;
  }
}
</style>
